import generateFilterForQuery from './_tools';

export class DealPaymentsStatisticQuery {

  static build(query: any) {

    const filter = generateFilterForQuery(query);

    return {
      columns: DealPaymentsStatisticQuery.COLUMNS,
      from: DealPaymentsStatisticQuery.FROM,
      from_as: DealPaymentsStatisticQuery.FROM_AS,
      joins: DealPaymentsStatisticQuery.JOINS,
      groups: DealPaymentsStatisticQuery.GROUPS,
      // page_size: DealPaymentsStatisticQuery.PAGE_SIZE,
      // ...({page: parseInt(query.page) || 1}),
      ...({
          order: [
            { $asc: [ 'pt.name' ] }
          ]
      }),
      where: {
        $and: [
        {$gt: ['dpc.container_price', {$: '0'}]},
        {$in: [
          'dpc.deal_id',
          {
            columns: {
              id: 'deal.id'
            },
            from: 's:deals',
            from_as: 'deal',
            joins: [
              {
                join: 's:clients',
                as: 'client',
                on: {
                  $eq: [
                    'deal.client_id',
                    'client.id'
                  ]
                }
              },
              {
                join: 's:delivery_points',
                type: 'left',
                as: 'point',
                on: {
                  $eq: [
                    'deal.delivery_point_id',
                    'point.id'
                  ]
                }
              },
              {
                join: 's:cities',
                type: 'left',
                as: 'city',
                on: {
                  $eq: [
                    'point.city_id',
                    'city.id'
                  ]
                }
              },
              {
                join: 's:statuses',
                type: 'left',
                as: 'status',
                on: {
                  $eq: [
                    'deal.status_id',
                    'status.id'
                  ]
                }
              },
              {
                join: 's:delivery_points',
                type: 'left',
                as:   'delivery_points',
                on: {
                  $eq: ['delivery_points.id', 'deal.delivery_point_id']
                }
              },
              {
                join: {
                  columns: {
                    deal_id: 'dpc.deal_id',
                    sapmle_count: { $count: 'dpc.id' }
                  },
                  from: 's:deal_product_containers',
                  from_as: 'dpc',
                  joins: [
                    {
                      join: 's:product_containers',
                      type: 'left',
                      as:   'pc',
                      on: {
                        $eq: ['pc.id', 'dpc.product_container_id']
                      }
                    },
                  ],
                  groups: [
                    'dpc.deal_id'
                  ],
                  where: {
                    $or: [
                      { $eq: ['dpc.is_sample', { $: true } ] },
                      { $eq: ['pc.is_sample', { $: true } ] },
                    ]
                  }
                },
                type: 'left',
                as: 'dpc_with_samples',
                on: { $eq: ['dpc_with_samples.deal_id', 'deal.id'] }
              }
            ],
            where: {
              $and: [
                {
                  $or: [
                    { $null: [ 'status.final' ] },
                    { $eq: [ 'status.final', { $: 'success'}]}
                  ]
                },
                ...filter
              ]
            }
          }
        ]}
      ]}
    }
  }

  static COLUMNS: any = {
    type_name: 'pt.name',
    return: { $eq: ['d.type_id', {$: 'd:deals_types:3'}] },
    not_return: { $not: [{ $eq: ['d.type_id', {$: 'd:deals_types:3'}] }]},
    amount: {
      $sum: 'dpc.container_price'
    }
  };

  static FROM: string = 's:deal_product_containers';
  static FROM_AS: string = 'dpc';

  static JOINS: any[] = [
    {
      join: 's:deals',
      as: 'd',
      on: {
        $eq: [
          'd.id',
          'dpc.deal_id'
        ]
      }
    },
    {
      join: 's:payment_types',
      as: 'pt',
      type: 'left',
      on: {
        $eq: [
          'pt.id',
          'd.payment_type_id'
        ]
      }
    }
  ]

  static GROUPS: any[] = [
    'pt.id',
    'pt.name',
    'd.type_id',
  ]
}
